import * as React from 'react';
import ReactTable from 'react-table';
import Asset from '../models/asset';
import  PortalView from './portal';
import { Input, Label, Dropdown, Button, Message } from 'semantic-ui-react';
import axios, { CancelTokenSource, AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus, DataRequest, Response } from '../api';
import ManifestView from './manifest';
import TraceRouteView from './traceroute';
import CustomPagination from '../sys/pagination';
import SetFilter from '../sys/setFilter';
import { default as Renderers } from '../sys/columns';
import ScanScheduleControl from '../sys/ScanScheduleControl';
const _ = require('lodash');
const FontAwesome = require('react-fontawesome');

class State {
    data: Array<Asset>;
    groupby: Array<string>;
    showManifestWindow: boolean;
    showTracerouteWindow: boolean;
    streamid: number;
    streamName: string;
    url: string;
    tracerouteStreamid: number;
    tracerouteStreamName: string;
    tracerouteUrl: string;
    nameFilter: string;
    setFilter: any;
    statusFilter: any;
    initiatorFilter: any;
    formatFilter: any;
    refresh ?: number;
    sharedManifest ?: boolean;
    streamType ?: string;
    masterFile ?: boolean;
}

interface Props {
}

export default class AssetsView extends React.Component<Props, State> {
    protected columns = [{
            width: 15,
        }, {
            id: 'actions',
            width: 100,
            sortable: false,
            accessor: 'status.streamid',
            Cell: (props: any) => this.buttonRenderer(props)
        },
        {
            Header: 'Name',
            accessor: 'status.name',
            headerStyle: { textAlign: 'left' },
            width: 500,
            resizable: true,
            sortable: false,
            Cell: (props: any) => this.assetNameRenderer(props),

        }, {
            Header: 'Status',
            headerStyle: { textAlign: 'left' },
            accessor: 'status.status',
            width: 210,
            resizable: true,
            Cell: (props: any) => Renderers.tooltip(props.value),
            aggregate: (values: any, row: any) => (values.length > 0) ? _.uniq(values) : null,

        }, {
            Header: 'Host',
            accessor: 'status.url',
            headerStyle: { textAlign: 'left' },
            width: 230,
            Aggregated: (row: any) => { return null; },
            resizable: true,
            Cell: (props: any) => this.hostUrlRenderer(props.value),
        }, {
            Header: 'Details',
            accessor: 'status.detail',
            headerStyle: { textAlign: 'left' },
            width: 200,
            sortable: true,
            resizable: false,
            Cell: (props: any) => Renderers.tooltip(props.value),
            Aggregated: (row: any) => null
        }, {
            Header: (h: any) => <span>Media Bandwidth<br/>(kbps)</span>,
            accessor: 'status.bitrate',
            headerStyle: { textAlign: 'left' },
            width: 140,
            Cell: (props: any) => this.mediaBandwidthRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }, {
            Header: 'Current Server IP',
            accessor: 'status',
            headerStyle: { textAlign: 'left' },
            width: 250,
            sortable: false,
            resizable: false,
            Cell: (props: any) => this.serverIpRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }, {
            Header: (h: any) => <span>VOD<br/>Play Count</span>,
            accessor: 'statistics.cycle',
            headerStyle: { textAlign: 'left' },
            sortable: false,
            Cell: (props: any) => this.vodPlaysRenderer(props)
        }, {
            Header: 'HTTP Connection Errors',
            columns: [
                {
                    Header: 'Open',
                    accessor: 'statistics.cycle',
                    headerStyle: { textAlign: 'left' },
                    sortable: false,
                    Cell: (props: any) => this.httpOpenRenderer(props.value)
                }, {
                    Header: 'Close',
                    accessor: 'statistics.cycle',
                    headerStyle: { textAlign: 'left' },
                    sortable: false,
                    Cell: (props: any) => this.httpCloseRenderer(props.value)
                }, {
                    Header: 'Other',
                    accessor: 'statistics.cycle',
                    headerStyle: { textAlign: 'left' },
                    sortable: false,
                    Cell: (props: any) => this.httpOtherRenderer(props.value)
                }
            ]
        }, {
            Header: 'Open Alarms',
            accessor: 'statistics.cycle',
            headerStyle: { textAlign: 'left' },
            sortable: false,
            Cell: (props: any) => this.openAlarmsRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }];
    private dataRefresh: () => void;
    private updateTimer: number;
    private cancelTokens: {
        update?: CancelTokenSource;
    };
    private addSetMembership: boolean;

    componentWillMount() {
        Renderers.ReactTable(this.columns);
        this.setState({
            refresh: 2500,
            data: [],
            groupby: [],
            showManifestWindow: false,
            showTracerouteWindow: false,
            nameFilter: '',
            setFilter: '',
            statusFilter: '',
            initiatorFilter: '',
            formatFilter: '',
            sharedManifest: false,
            streamType: '',
            masterFile: false
        });

        this.cancelTokens = {};
        // tslint:disable-next-line:no-empty
        this.dataRefresh = function() { };
    }
    componentDidMount() {
        this.openManifestWindowPortal = this.openManifestWindowPortal.bind(this);
        this.closeManifestWindowPortal = this.closeManifestWindowPortal.bind(this);

        this.openTracerouteWindowPortal = this.openTracerouteWindowPortal.bind(this);
        this.closeTracerouteWindowPortal = this.closeTracerouteWindowPortal.bind(this);

        window.addEventListener('beforeunload', () => {
            this.closeManifestWindowPortal();
            this.closeTracerouteWindowPortal();
        });
    }

    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);

        // cancel any pending requests
        if (this.cancelTokens.update !== undefined)
            this.cancelTokens.update.cancel();

        this.setRefreshInterval = this.setRefreshInterval.bind(this);
    }

    setRefreshInterval(interval?: number) {
        this.setState({ refresh: interval });
    }

    openManifestWindowPortal() {
        this.setState(state => ({
            ...state,
            showManifestWindow: true
        }));
    }

    closeManifestWindowPortal() {
        this.setState({ showManifestWindow: false });
    }

    closeTracerouteWindowPortal() {
        this.setState({showTracerouteWindow: false });
    }

    openTracerouteWindowPortal() {
            this.setState(state => ({
                ...state,
                showTracerouteWindow: true
    }));
}

    render() {

        const statusOptions = [{value: '', text: 'All'}, {value: 'good', text: 'Good'},
            {value: 'alarmed', text: 'Alarmed'}, {value: 'outage', text: 'Outage'}];

        const formatOptions = [{value: '', text: 'All'}, {value: 'dash', text: 'DASH'}, {value: 'hls', text: 'HLS'},
            {value: 'hss', text: 'HSS'}, {value: 'hds', text: 'HDS'}];

        const initiatorOptions = [{value: '', text: 'All'}, {value: 'manual', text: 'Manual'},
            {value: 'scan', text: 'Scan'}, {value: 'schedule', text: 'Schedule'},
            {value: 'api', text: 'API'}];

        let streamParam = this.getParams();

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    const vodMode = oauth.sys && oauth.sys.interface === 'vod';
                    const columns = vodMode
                        ? this.columns.filter(c => c.id !== 'actions')
                        : this.columns;
                    const activeStreams = oauth.sys ? oauth.sys.activeStreams : '-';
                    const activePlaylists = oauth.sys ? oauth.sys.activePlaylists : '-';
                    const licenseFlowLimit = oauth.sys ? oauth.sys.licenseFlowLimit : '-';
                    return (
                        <div className="view-content" id="assets">

                            <div className="pageTitle displayFlex">
                                <div className="page-title-block">
                                    <div className="iq-temp-key-val">
                                        <div className="iq-temp-val page-title-text"> Asset Status</div>
                                    </div>
                                </div>
                                <div className="iq-temp-key-val">
                                    <div className="iq-temp-key">Session Max</div>
                                    <div className="iq-temp-val"> {licenseFlowLimit}</div>
                                </div>
                                <div className="iq-temp-key-val">
                                    <div className="iq-temp-key">Active Sessions</div>
                                    <div className="iq-temp-val"> {activeStreams}</div>
                                </div>
                                <div className="iq-temp-key-val">
                                    <div className="iq-temp-key">Playlists Max</div>
                                    <div className="iq-temp-val"> {licenseFlowLimit}</div>
                                </div>
                                <div className="iq-temp-key-val">
                                    <div className="iq-temp-key">Active Playlists</div>
                                    <div className="iq-temp-val"> {activePlaylists}</div>
                                </div>
                                <div className="floatRight">
                                    <ScanScheduleControl scan schedule/>
                                    <Button
                                        className="rightButton"
                                        content="Stop Set"
                                        disabled={vodMode}
                                        onClick={() => this.handleSet(this.state.setFilter, 'stop')}
                                    />
                                    <Button
                                        className="rightButton"
                                        content="Start Set"
                                        disabled={vodMode}
                                        onClick={() => this.handleSet(this.state.setFilter, 'start')}
                                    />
                                </div>
                            </div>
                            <div className="filterPanel">
                                <Label className="filterPanelLabel">
                                    Name
                                </Label>
                                <Input
                                    className="filterPanelSearchBox"
                                    value={this.state.nameFilter}
                                    onChange={(event, data) => this.setState({nameFilter: data.value}, this.dataRefresh)}
                                />
                                <Label className="filterPanelLabel">
                                    Set
                                </Label>
                                <SetFilter
                                    setFilter={this.state.setFilter}
                                    onChange={(event: any, data: any) => this.setState({setFilter: data.value}, this.dataRefresh)}
                                />
                                <Label className="filterPanelLabel">
                                    Status
                                </Label>
                                <Dropdown
                                    className="alarmLogDropDown"
                                    placeholder="All"
                                    search
                                    selection
                                    options={statusOptions}
                                    value={this.state.statusFilter}
                                    onChange={(event, data) => this.setState({statusFilter: data.value}, this.dataRefresh)}
                                />
                                <Label className="filterPanelLabel">
                                    Type
                                </Label>
                                <Dropdown
                                    className="alarmLogDropDown"
                                    placeholder="All"
                                    search
                                    selection
                                    options={formatOptions}
                                    value={this.state.formatFilter}
                                    onChange={(event, data) => this.setState({formatFilter: data.value}, this.dataRefresh)}
                                />
                                <Label className="filterPanelLabel">
                                    Initiator
                                </Label>
                                <Dropdown
                                    className="alarmLogDropDown"
                                    placeholder="All"
                                    search
                                    selection
                                    options={initiatorOptions}
                                    value={this.state.initiatorFilter}
                                    onChange={(event, data) => this.setState({initiatorFilter: data.value}, this.dataRefresh)}
                                />
                                <div className="spacer"/>
                                {/*<Button className="filterPanel-primary-btn" content="Filter" onClick={() => this.handleFilter()}/>*/}
                                <Button className="filterPanel-secondary-btn" content="Reset" onClick={() => this.handleReset()}/>
                                <PortalView active={this.state && this.state.showManifestWindow} closeWindowPortal={this.closeManifestWindowPortal} title="Playlist/Manifest Files">
                                    {/* tslint:disable-next-line:max-line-length */}
                                    <ManifestView streamid={this.state.streamid} streamName={this.state.streamName} url={this.state.url} sharedManifest={this.state.sharedManifest} streamType={this.state.streamType} masterFile={this.state.masterFile}/>
                                </PortalView>

                                <PortalView active={this.state && this.state.showTracerouteWindow} closeWindowPortal={this.closeTracerouteWindowPortal} title="Traceroute">
                                    <TraceRouteView
                                        streamid={this.state.tracerouteStreamid}
                                        streamName={this.state.tracerouteStreamName}
                                        url={this.state.tracerouteUrl}
                                    />
                                </PortalView>

                            </div>
                            {vodMode && <Message className="flat" inverted color="orange">
                                <span className="interface-mode interface-mode-vod">vod</span>
                                Actions on assets are not available while in VOD mode
                            </Message>}
                            <div className="view-clientarea">
                                <DataRequest
                                    auto              // automatically request on data change (filter change)
                                    spinner             // show spinner when foreground loading (ex. on first load)
                                    debounce={1500}     // debounce multiple requests (i.e. as user types in filter box)
                                    interval={this.state.refresh}     // update every 10 seconds
                                    method="post"
                                    endpoint="api/analytics"
                                    // orderBy="order results.session by status.streamid asc"
                                    treeOrder={true}
                                    data={{
                                        streams: streamParam,
                                        // tslint:disable-next-line:max-line-length
                                        name: this.state.nameFilter.length ? ((this.state.nameFilter.startsWith('\'') && this.state.nameFilter.endsWith('\'')) || (this.state.nameFilter.startsWith('\"') && this.state.nameFilter.endsWith('\"'))) ? this.state.nameFilter.slice(1, this.state.nameFilter.length - 1) : this.state.nameFilter : undefined,
                                        setMembership: this.addSetMembership ? this.state.setFilter : undefined,
                                        namespace: 'api.surveyor.abr',
                                        timerange: 'current',
                                        metrics: ['session.status', 'session.statistics.cycle']
                                    }}
                                >{(request: Response) => {
                                    // save the refresh function for later use
                                    this.dataRefresh = request.refresh;

                                    // render a react table using the request data
                                    return (
                                        <ReactTable
                                            className="transaction-log -striped -highlight outside-scroll"
                                            //  pivotBy={ this.state.groupby }
                                            onFetchData={request.refresh}
                                            data={(request.data && request.data.results && request.data.results.session) || []} // (this.state && this.state.data) ? this.state.data : []}
                                            columns={columns}
                                            // defaultSorted={[
                                            //     {
                                            //         id: 'status.name',
                                            //         asc: true
                                            //     }
                                            // ]}
                                            defaultPageSize={16}
                                            PaginationComponent={CustomPagination}
                                            NoDataComponent={request.spinner ? () => null : undefined}
                                        />
                                    );
                                }}
                                </DataRequest>
                            </div>
                        </div>
                    );
                }}
            </OAuth.Context>
        );
    }

    handleSet(setValue: any, operation: string) {
        let url = 'http://default/api/stream/control/' + operation;
        let data = {};
        (setValue === '' ? setValue = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : setValue = setValue);
        if (operation === 'start') {
            data = {
                'streams': 'idle and setMembership',
                'setMembership': setValue,
                'client': 'User'
            };
        } else if (operation === 'stop') {
            data = {
                'streams': 'census and setMembership',
                'setMembership': setValue,
                'client': 'User'
            };
        }

        axios.post( url, data)
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined && resp.data.code === 'SUCCESS' ) {
                    this.dataRefresh();     // todo: how do we link this to the component? a ref?
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('error ', resp.data);
                }
            })
            .catch( (err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('scheduling error: ', err);
            });
    }

    scheduleNextUpdate(ms ?: number) {
        if (ms === undefined)
            ms = this.state.refresh;
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
        // if (this.componentIsMounted)
        this.updateTimer = window.setTimeout(this.dataRefresh, ms);
    }

    getParams() {
        let stream = (this.state.nameFilter !== undefined && this.state.nameFilter.length > 0)
            ?  ((this.state.nameFilter.startsWith('\'') && this.state.nameFilter.endsWith('\'')) || (this.state.nameFilter.startsWith('\"') && this.state.nameFilter.endsWith('\"'))) ? 'name' : 'name%'
            : 'all';

        if (this.state.setFilter !== undefined && this.state.setFilter !== '') {
            stream += ' and setMembership';
            this.addSetMembership = true;
        }
        if (this.state.statusFilter !== '') {
            if ( this.state.statusFilter === 'alarmed') {
                stream += ' and alarmed';
            } else if ( this.state.statusFilter === 'outage') {
                stream += ' and outage';
            } else if ( this.state.statusFilter === 'good') {
                stream += ' and (!alarmed and !errored and !outage and !idle)';
            }
        }
        if (this.state.formatFilter !== '') {
            if ( this.state.formatFilter === 'dash') {
                stream += ' and dash';
            } else if ( this.state.formatFilter === 'hls') {
                stream += ' and hls';
            } else if ( this.state.formatFilter === 'hss') {
                stream += ' and hss';
            } else if ( this.state.formatFilter === 'hds') {
                stream += ' and hds';
            }
        }
        if (this.state.initiatorFilter !== '') {
            if ( this.state.initiatorFilter === 'manual') {
                stream += ' and manual';
            } else if ( this.state.initiatorFilter === 'scan') {
                stream += ' and scanning ';
            } else if ( this.state.initiatorFilter === 'schedule') {
                stream += ' and (scheduling or eventScheduling)';
            } else if ( this.state.initiatorFilter === 'api') {
                stream += ' and api';
            }
        }
        return stream;
    }

    manageAsset(props: any) {

        let url = 'http://default/api/stream/' + props.original.status.streamid + '/control/start';
        if (props.original.status.state !== 'IDLE')
            url = 'http://default/api/stream/' + props.original.status.streamid + '/control/stop';

        axios.post(url, {
            'client': 'User',
        })
            .then((rsp: AxiosResponse) => {
                if (rsp !== undefined && this.dataRefresh) {
                    this.dataRefresh();
                }
            })
            .catch( (err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('manageAsset() error: ', err);
            });
    }

    openManifestWindow(props: any) {
        this.setState({
            streamid: props.original.status.streamid,
            streamName: props.original.status.name,
            url: props.original.status.url,
            sharedManifest: props.original.status.sharedManifest,
            streamType: props.original.status.streamType,
            masterFile: props.original.status.master
        });
        this.openManifestWindowPortal();
    }

    openTraceRouteWindow(props: any) {

        this.setState({
            tracerouteStreamid: props.original.status.streamid,
            tracerouteStreamName: props.original.status.name,
            tracerouteUrl: props.original.status.mediaIP
        });
        this.openTracerouteWindowPortal();
    }

    buttonRenderer(props: any): React.ReactNode {
        let iconBasedOnEvent = 'fa fa-stop-circle-o iq-color-green';

        if ( props.original.status.status === 'DNS SERVER CONFIG' || props.original.status.status === 'DNS LOOKUP FAILED' ||
            props.original.status.status === 'SERVER CONNECTION FAILED' || props.original.status.status === 'UNKNOWN' ||
            props.original.status.status === 'KEY SERVER CONNECTION FAILED' || props.original.status.status === 'AUTHORIZATION SERVER CONNECTION FAILED'
        ) {
            iconBasedOnEvent = 'fa fa-stop-circle-o iq-color-red';
        } else if (!props.original.status.master && props.original.status.status !== 'IDLE') {
            iconBasedOnEvent = 'fa fa-stop-circle-o iq-color-green';
        }

        // let icon = ' ';
        let title = 'Stop Stream \n' +  props.original.status.status;
        if (props.original.status.state === 'IDLE') {
            title = 'Start Stream \n' +  props.original.status.status;
        }
        let traceRouteTitle = 'Traceroute';
        let traceRouteDisabled = false;
        if (props.original.status.master) {
            traceRouteTitle = 'Master Stream - No Traceroute Available';
            traceRouteDisabled = true;
        }
        let unplayable = false;
        if (props.original.status.playable === false) {
            title = 'Unplayable \n' +  props.original.status.status;
            unplayable = true;
        }

        if (props.original.status.state === 'IDLE') {
            return (
                <div className="cellIcons">
                    <Button disabled={unplayable}  title={title} className="grid-hamburger-menu-button" onClick={() => this.manageAsset(props)}>
                        <FontAwesome name="play-circle" />
                    </Button>
                    <Button title="Playlist/Manifest Files" className="grid-hamburger-menu-button iconSpacing" onClick={() => this.openManifestWindow(props)}>
                        <FontAwesome name="th" />
                    </Button>
                    <div title={traceRouteTitle} >
                        <Button disabled={traceRouteDisabled} className="grid-hamburger-menu-button" onClick={() => this.openTraceRouteWindow(props)}>
                            <FontAwesome name="exchange" title={traceRouteTitle} />
                        </Button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="cellIcons">
                    <Button disabled={unplayable} title={title} className="grid-hamburger-menu-button" onClick={() => this.manageAsset(props)}>
                        <span className="stop-pulse"> <i className={iconBasedOnEvent} aria-hidden="true"/> </span>
                    </Button>
                    <Button title="Playlist/Manifest Files" className="grid-hamburger-menu-button iconSpacing" onClick={() => this.openManifestWindow(props)}>
                        <FontAwesome name="th"/>
                    </Button>
                    <div title={traceRouteTitle}>
                        <Button disabled={traceRouteDisabled} className="grid-hamburger-menu-button" onClick={() => this.openTraceRouteWindow(props)}>
                            <FontAwesome name="exchange" title={traceRouteTitle}/>
                        </Button>
                    </div>
                </div>
            );
        }
    }

    // assetStatusRenderer(props: any): React.ReactNode  {
    //     // let clsBan = 'fa fa-ban iq-color-red';
    //     // if ( props.original.status.status === 'DNS SERVER CONFIG' || props.original.status.status === 'DNS LOOKUP FAILED' ||
    //     //     props.original.status.status === 'SERVER CONNECTION FAILED' || props.original.status.status === 'UNKNOWN' ||
    //     //     props.original.status.status === 'KEY SERVER CONNECTION FAILED' || props.original.status.status === 'AUTHORIZATION SERVER CONNECTION FAILED'
    //     // ){
    //     //     return <i className={clsBan} title= {props.original.status.status} aria-hidden="true"></i>;
    //     // } else if( !props.original.status.master && props.original.status.status !== 'IDLE')
    //     //     return  <div style={{padding: '10px'}}  title= {props.original.status.status} ><span className="pulse"></span></div>;
    //     //     //return <div style={{padding: '0 10px'}}  title= {props.original.status.status} ><i className="fa fa-spinner fa-pulse fa-1x fa-fw"></i></div>;
    //
    //     return '';
    // }

    assetNameRenderer(props: any): React.ReactNode  {
        let clsName = 'td-colored-cell ';
        // SAN-3181: Check for stream type of 'HLS Component'.
        let master = props.original.status ? (props.original.status.master || props.original.status.streamType.endsWith('Component')) : false;
        let subRepMaster = props.original.status ? props.original.status.subRepId === props.original.status.streamId : false;
        let subRep = props.original.status ? props.original.status.subRep : false;

        // determine how to display data for sub-representations.
        if (master && !subRepMaster && !subRep) {
            clsName += 'assetName';
        } else if (!master && subRepMaster && subRep) {
            clsName = 'variantName';
        } else if (!master && !subRepMaster && subRep) {
            clsName += 'variantName subRepName';
        } else {
            clsName += 'variantName';
        }

        return <div className={clsName} title={props.original.status.name}> {props.original.status.name} </div>;
    }

    hostUrlRenderer(url: any): React.ReactNode {
        let hostUrl = (url ? url.split('/') : null);
        let returnStr = '';
        if (hostUrl !== null) {
            (hostUrl[2] === '')
                ? returnStr = '0.0.0.0'
                : returnStr = hostUrl[2];
        } else {
            returnStr = hostUrl;
        }
        return (
            <div title={returnStr}>
                {returnStr}
            </div>
        );
    }

    serverIpRenderer(props: any): React.ReactNode {

        if (props.manifestIP !== undefined) {
            let text = (props.mediaIP ? props.manifestIP + ' / ' + props.mediaIP : props.manifestIP);
            return (
                <div title={text}>
                    {text}
                </div>
            );
        } else
            return <div>-</div>;
    }

    mediaBandwidthRenderer(props: any) {

        if (props === 0)
            return '-';
        else
            return Math.trunc(props / 1000);
    }

    vodPlaysRenderer(props: any) {
        if ((props.original.statistics.cycle[0] !== undefined) && (props.original.statistics.cycle[0].files.media.VODPlays !== 0)) {

            return props.original.statistics.cycle[0].files.media.VODPlays;
        }
        return '-';
    }

    httpOpenRenderer(props: any) {
        if ((props[props.length - 1]) !== undefined) {

            return props[props.length - 1].connection.errors;
        }
        return '-';

    }

    httpCloseRenderer(props: any) {
        if ((props[props.length - 1]) !== undefined) {

            return props[props.length - 1].http.close;
        }
        return '-';

    }

    httpOtherRenderer(props: any) {
        if ((props[props.length - 1]) !== undefined) {

            return  (props[props.length - 1].http.socketErrors);
        }
        return '-';

    }
    openAlarmsRenderer(props: any) {
        if ((props[props.length - 1]) !== undefined) {

            return  (props[props.length - 1].general.alarms.count);
        }
        return '-';

    }

    // Set interval to 1 second for call for data to take effect immediately.
    // Set it back to previous refresh interval immediately after.
    handleFilter() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);
    }

    // Set interval to 1 second for call for data to take effect immediately.
    // Set it back to previous refresh interval immediately after.
    handleReset() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        this.setState({
            nameFilter: '',
            setFilter: '',
            statusFilter: '',
            initiatorFilter: '',
            formatFilter: ''
        },
                      this.dataRefresh);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/assets.tsx